var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:('width:100%;height:'+_vm.schema.height+'px;background:'+_vm.schema.bgColor + _vm.colorTransparent(_vm.schema.transparent)+';')})
}
var staticRenderFns = []

export { render, staticRenderFns }